export default "__VITE_ASSET__DV1brfG1__"